// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OnLine_container__lxmZb .OnLine_content__gFVdt {
  justify-content: center;
  align-items: center;
}

.OnLine_container__lxmZb .OnLine_content__gFVdt .OnLine_bankContainer__9y8c- {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
}

.OnLine_depositContainer__Lmk7N {
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.OnLine_itemTitle__rdeUz {
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 2px;
}

.OnLine_money__rUFlo {
  font-size: 1.2rem;
  font-weight: lighter;
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 2px;
}

.OnLine_iconOptions__Lc3SK {
  transition: 0.3s;
}

.OnLine_iconOptions__Lc3SK:hover {
  scale: 1.03;
  filter: brightness(0.6);
  transition: 0.3s;
  cursor: pointer;
}

.OnLine_qr__B7fWU {
  text-align: center;
}

.OnLine_title__vsFW- {
  justify-content: flex-start;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 1px;
  font-size: 1.7em;
}

.OnLine_date__Pe43K {
  scale: 1;
  width: 100%;
  text-align: start;
}

.OnLine_inputationDate__rdi7v {
  font-size: 1rem;
}

.OnLine_pagination__18dwD {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
  padding-bottom: 40px;
  width: 100%;
}

.OnLine_container__lxmZb .OnLine_content__gFVdt .OnLine_noAgencieSelected__z9g-D {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.OnLine_container__lxmZb .OnLine_content__gFVdt .OnLine_noAgencieSelected__z9g-D h3 {
  font-size: 32px;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-top: 10%;
}

.OnLine_container__lxmZb .OnLine_content__gFVdt .OnLine_noAgencieSelected__z9g-D .OnLine_redirectBtn__RaRQM {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width: 20%;
  border-radius: 10px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.298);
}

.OnLine_container__lxmZb .OnLine_content__gFVdt .OnLine_noAgencieSelected__z9g-D .OnLine_redirectBtn__RaRQM:hover {
  transition: 0.3s;
  cursor: pointer;
  scale: 1.06;
  filter: brightness(1.3);
  box-shadow: 0px 0px 15px -3px rgba(255, 255, 255, 0.298);
}
.OnLine_container__lxmZb .OnLine_selectAgency__kKofF {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.OnLine_container__lxmZb .OnLine_content__gFVdt .OnLine_tabContainer__oFfuN {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  max-height: 47px;
}

.OnLine_container__lxmZb .OnLine_content__gFVdt .OnLine_tabContainer__oFfuN .OnLine_tabs__8cHHe .MuiTabs-indicator {
  display: none;
}

.OnLine_container__lxmZb .OnLine_content__gFVdt .OnLine_tabContainer__oFfuN .OnLine_tabs__8cHHe .OnLine_tabItem__gteDl {
  border: 1px solid #e9e9e9;
  background: #f7f7f7;
  font-size: 0.7em;
  border-radius: 15px 15px 0 0;
  margin-left: 5px;
  text-transform: capitalize;
}

.OnLine_container__lxmZb .OnLine_content__gFVdt .OnLine_tabContainer__oFfuN .OnLine_tabs__8cHHe .OnLine_selected__3zMr- {
  transition-delay: 0.2s;
  border-bottom-width: 0;
  background-color: #ffffff;
}

.OnLine_container__lxmZb .OnLine_content__gFVdt .OnLine_render__uVeku {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #e9e9e9;
}

/* New styles */

.OnLine_container__lxmZb {
  animation: OnLine_init__VYvyr 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/*--Header--*/
.OnLine_container__lxmZb .OnLine_header__aeHWi {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.OnLine_container__lxmZb .OnLine_header__aeHWi .OnLine_titleContainer__XZK5h {
  animation: OnLine_init2__1o2KS 0.3s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.OnLine_container__lxmZb .OnLine_header__aeHWi .OnLine_titleContainer__XZK5h h4 {
  text-align: center;
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.OnLine_container__lxmZb .OnLine_header__aeHWi .OnLine_titleContainer__XZK5h .OnLine_add_btn__LGWLW {
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
  width: 6.5rem;
  text-transform: capitalize;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-left: 10px;
}

.OnLine_container__lxmZb .OnLine_filters__G8DWY {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.OnLine_filterButton__y22kL {
  animation: OnLine_init3__8kbl5 0.3s both;
  height: 3rem;
  width: 10rem;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.OnLine_filterButton__y22kL p {
  text-transform: capitalize;
  margin-left: 5px;
  font-weight: 400;
}

.OnLine_container__lxmZb .OnLine_tableContainer__0m9yq {
  animation: OnLine_init3__8kbl5 0.3s both;
  width: 100%;
  max-height: 250px;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.168);
}

.OnLine_container__lxmZb .OnLine_loader__pEtU1 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.OnLine_wrapper__rEisT {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 2rem;
  width: 100%;
}

.OnLine_section__inL3b {
  width: 100%;
  margin: 16px 0;
}

.OnLine_balanceContainer__eKLB4 {
  color: var(--mui-palette-primary-light);
  background-color: var(--mui-palette-primary-dark);
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
}

.OnLine_balanceText__lsM05 {
  font-weight: 400;
  margin: 0;
}

.OnLine_tableWrapper__1RkKY {
  width: 100%;
}

.OnLine_tableContainer__0m9yq {
  width: 100%;
}

.OnLine_table__htpRi {
  width: 100%;
}

.OnLine_tableHeadCell__9HPiX {
  font-size: 0.9rem;
  font-weight: 400;
}

.OnLine_tableCell__YU7gc {
  font-size: 0.9rem;
}

.OnLine_rowEven__GoiW5 {
  background-color: #dddddd;
}

.OnLine_rowOdd__JkLBj {
  background-color: white;
}

.OnLine_paginationContainer__8z406 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
  width: 100%;
}

.OnLine_loader__pEtU1 {
  width: 100%;
  text-align: center;
}


@keyframes OnLine_init__VYvyr {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes OnLine_init2__1o2KS {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes OnLine_init3__8kbl5 {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@media print {
  .OnLine_titleContainer__XZK5h {
    display: none !important;
  }
  .OnLine_header__aeHWi {
    display: none !important;
  }
  .OnLine_filters__G8DWY {
    display: none !important;
  }
  .OnLine_filterButton__y22kL {
    display: none !important;
  }
  .OnLine_selectAgency__kKofF {
    display: none !important;
  }
  .OnLine_bankContainer__9y8c- {
    display: none !important;
  }
  .OnLine_icon__gCqYI {
    display: none !important;
  }
  .OnLine_optionButton__Uets8 {
    display: none !important;
  }
  .OnLine_optionsContainer__2Mim7 {
    display: none !important;
  }
  .OnLine_pagination__18dwD {
    display: none !important;
  }
  .OnLine_noResultContainer__wht6N {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/OnLine/index.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,wDAAwD;AAC1D;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,eAAe;;AAEf;EACE,gCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,wCAA0B;EAC1B,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wCAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wCAA0B;EAC1B,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;;AAGA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".container .content {\n  justify-content: center;\n  align-items: center;\n}\n\n.container .content .bankContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 15%;\n}\n\n.depositContainer {\n  padding: 10px;\n  border-radius: 10px;\n  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n}\n\n.itemTitle {\n  font-size: 1rem;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n.money {\n  font-size: 1.2rem;\n  font-weight: lighter;\n  background-color: white;\n  padding: 5px;\n  border-radius: 5px;\n  text-align: center;\n  margin-bottom: 2px;\n}\n\n.iconOptions {\n  transition: 0.3s;\n}\n\n.iconOptions:hover {\n  scale: 1.03;\n  filter: brightness(0.6);\n  transition: 0.3s;\n  cursor: pointer;\n}\n\n.qr {\n  text-align: center;\n}\n\n.title {\n  justify-content: flex-start;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 1px;\n  font-size: 1.7em;\n}\n\n.date {\n  scale: 1;\n  width: 100%;\n  text-align: start;\n}\n\n.inputationDate {\n  font-size: 1rem;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 40px;\n  padding-bottom: 40px;\n  width: 100%;\n}\n\n.container .content .noAgencieSelected {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .content .noAgencieSelected h3 {\n  font-size: 32px;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-top: 10%;\n}\n\n.container .content .noAgencieSelected .redirectBtn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  width: 20%;\n  border-radius: 10px;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.298);\n}\n\n.container .content .noAgencieSelected .redirectBtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  scale: 1.06;\n  filter: brightness(1.3);\n  box-shadow: 0px 0px 15px -3px rgba(255, 255, 255, 0.298);\n}\n.container .selectAgency {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .content .tabContainer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  max-height: 47px;\n}\n\n.container .content .tabContainer .tabs :global .MuiTabs-indicator {\n  display: none;\n}\n\n.container .content .tabContainer .tabs .tabItem {\n  border: 1px solid #e9e9e9;\n  background: #f7f7f7;\n  font-size: 0.7em;\n  border-radius: 15px 15px 0 0;\n  margin-left: 5px;\n  text-transform: capitalize;\n}\n\n.container .content .tabContainer .tabs .selected {\n  transition-delay: 0.2s;\n  border-bottom-width: 0;\n  background-color: #ffffff;\n}\n\n.container .content .render {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  width: 100%;\n  background-color: #ffffff;\n  border: 1px solid #e9e9e9;\n}\n\n/* New styles */\n\n.container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n/*--Header--*/\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: init2 0.3s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  text-align: center;\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .header .titleContainer .add_btn {\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.5rem;\n  width: 6.5rem;\n  text-transform: capitalize;\n  border-radius: 5px;\n  font-size: 1rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-left: 10px;\n}\n\n.container .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.filterButton {\n  animation: init3 0.3s both;\n  height: 3rem;\n  width: 10rem;\n  margin-left: 5px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.filterButton p {\n  text-transform: capitalize;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n.container .tableContainer {\n  animation: init3 0.3s both;\n  width: 100%;\n  max-height: 250px;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.168);\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 2rem;\n  width: 100%;\n}\n\n.section {\n  width: 100%;\n  margin: 16px 0;\n}\n\n.balanceContainer {\n  color: var(--mui-palette-primary-light);\n  background-color: var(--mui-palette-primary-dark);\n  border-radius: 5px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 16px;\n}\n\n.balanceText {\n  font-weight: 400;\n  margin: 0;\n}\n\n.tableWrapper {\n  width: 100%;\n}\n\n.tableContainer {\n  width: 100%;\n}\n\n.table {\n  width: 100%;\n}\n\n.tableHeadCell {\n  font-size: 0.9rem;\n  font-weight: 400;\n}\n\n.tableCell {\n  font-size: 0.9rem;\n}\n\n.rowEven {\n  background-color: #dddddd;\n}\n\n.rowOdd {\n  background-color: white;\n}\n\n.paginationContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 16px 0;\n  width: 100%;\n}\n\n.loader {\n  width: 100%;\n  text-align: center;\n}\n\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@keyframes init3 {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n@media print {\n  .titleContainer {\n    display: none !important;\n  }\n  .header {\n    display: none !important;\n  }\n  .filters {\n    display: none !important;\n  }\n  .filterButton {\n    display: none !important;\n  }\n  .selectAgency {\n    display: none !important;\n  }\n  .bankContainer {\n    display: none !important;\n  }\n  .icon {\n    display: none !important;\n  }\n  .optionButton {\n    display: none !important;\n  }\n  .optionsContainer {\n    display: none !important;\n  }\n  .pagination {\n    display: none !important;\n  }\n  .noResultContainer {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OnLine_container__lxmZb`,
	"content": `OnLine_content__gFVdt`,
	"bankContainer": `OnLine_bankContainer__9y8c-`,
	"depositContainer": `OnLine_depositContainer__Lmk7N`,
	"itemTitle": `OnLine_itemTitle__rdeUz`,
	"money": `OnLine_money__rUFlo`,
	"iconOptions": `OnLine_iconOptions__Lc3SK`,
	"qr": `OnLine_qr__B7fWU`,
	"title": `OnLine_title__vsFW-`,
	"date": `OnLine_date__Pe43K`,
	"inputationDate": `OnLine_inputationDate__rdi7v`,
	"pagination": `OnLine_pagination__18dwD`,
	"noAgencieSelected": `OnLine_noAgencieSelected__z9g-D`,
	"redirectBtn": `OnLine_redirectBtn__RaRQM`,
	"selectAgency": `OnLine_selectAgency__kKofF`,
	"tabContainer": `OnLine_tabContainer__oFfuN`,
	"tabs": `OnLine_tabs__8cHHe`,
	"tabItem": `OnLine_tabItem__gteDl`,
	"selected": `OnLine_selected__3zMr-`,
	"render": `OnLine_render__uVeku`,
	"init": `OnLine_init__VYvyr`,
	"header": `OnLine_header__aeHWi`,
	"titleContainer": `OnLine_titleContainer__XZK5h`,
	"init2": `OnLine_init2__1o2KS`,
	"add_btn": `OnLine_add_btn__LGWLW`,
	"filters": `OnLine_filters__G8DWY`,
	"filterButton": `OnLine_filterButton__y22kL`,
	"init3": `OnLine_init3__8kbl5`,
	"tableContainer": `OnLine_tableContainer__0m9yq`,
	"loader": `OnLine_loader__pEtU1`,
	"wrapper": `OnLine_wrapper__rEisT`,
	"section": `OnLine_section__inL3b`,
	"balanceContainer": `OnLine_balanceContainer__eKLB4`,
	"balanceText": `OnLine_balanceText__lsM05`,
	"tableWrapper": `OnLine_tableWrapper__1RkKY`,
	"table": `OnLine_table__htpRi`,
	"tableHeadCell": `OnLine_tableHeadCell__9HPiX`,
	"tableCell": `OnLine_tableCell__YU7gc`,
	"rowEven": `OnLine_rowEven__GoiW5`,
	"rowOdd": `OnLine_rowOdd__JkLBj`,
	"paginationContainer": `OnLine_paginationContainer__8z406`,
	"icon": `OnLine_icon__gCqYI`,
	"optionButton": `OnLine_optionButton__Uets8`,
	"optionsContainer": `OnLine_optionsContainer__2Mim7`,
	"noResultContainer": `OnLine_noResultContainer__wht6N`
};
export default ___CSS_LOADER_EXPORT___;
